document.addEventListener('DOMContentLoaded', function() {
  const dataElement = document.getElementById('variant-was-price-data');
  if (!dataElement) return;

  // Parse the data we passed from Liquid
  const variantWasPrices = JSON.parse(dataElement.textContent);
  const wasPriceElement = document.getElementById('variant-was-price');
  const wasPriceValue = document.getElementById('was-price-value');
  const variantSelector = document.querySelector('[name="id"]');

  function updateWasPrice(variantId) {
    const wasPrice = variantWasPrices[variantId];
    
    if (wasPrice && wasPriceValue && wasPriceElement) {
      wasPriceValue.textContent = wasPrice;
      wasPriceElement.style.display = 'block';
    } else if (wasPriceElement) {
      wasPriceElement.style.display = 'none';
    }
  }

  // Listen for changes
  variantSelector?.addEventListener('change', function(e) {
    updateWasPrice(e.target.value);
  });

  // Initial check (Shopify often sets the variant in the URL or default)
  const urlParams = new URLSearchParams(window.location.search);
  const currentVariantId = urlParams.get('variant') || variantSelector?.value;
  
  if (currentVariantId) {
    updateWasPrice(currentVariantId);
  }
});